import { withAssetPath, withBasePath } from "../utils/basePath";

export const SOCIAL_LINKS = {
  discord: {
    url: "https://discord.gg/ZtH6rZpa8y",
    label: "Discord",
    icon: withAssetPath("/assets/images/discord.svg"),
  },
  instagram: {
    url: "https://www.instagram.com/rythmfm/",
    label: "Instagram",
    icon: withAssetPath("/assets/images/instagram.svg"),
  },
  tiktok: {
    url: "https://www.tiktok.com/@rythmfm",
    label: "TikTok",
    icon: withAssetPath("/assets/images/tiktok.svg"),
  },
  twitter: {
    url: "https://twitter.com/rythmfm",
    label: "Twitter",
    icon: withAssetPath("/assets/images/twitter.svg"),
  },
} as const;

export const APP_LINKS = {
  invite: "https://rythm.fm/invite",
  home: withBasePath("/"),
  download: withBasePath("/download"),
  premium: withBasePath("/premium"),
  docs: "https://docs.rythm.fm",
  webApp: "https://app.rythm.fm",
  premiumSignup: "https://premium.rythm.fm/",
  discordActivity: "https://discord.com/discovery/applications/235088799074484224",
  discordBot: "https://discord.com/oauth2/authorize?client_id=235088799074484224&permissions=8&integration_type=0&scope=bot",
} as const;

export const LEGAL_LINKS = {
  termsOfService: withBasePath("/terms-of-service"),
  privacyPolicy: withBasePath("/privacy"),
  refundPolicy: withBasePath("/refund-policy"),
} as const;

export const BRAND = {
  name: "Rythm",
  logo: withAssetPath("/assets/images/logo-icon.svg"),
} as const;
